<app-profile [user$]="loggedinUser$">    
</app-profile>
